import { useParams } from "react-router-dom";
import { childHandshake, sendEventToParent } from "../services/dialog-service";
import { NotificationsContainer } from "../components/Notifications/NotificationsContainer";
import { TFilesRetriever, getFilesRetriever } from "../services/files-retriever";
import { useEffect, useState } from "react";
import { LoadingPresentational } from "../components/Loading/LoadingPresentational";
import { FolderExplorerContainer } from "../components/FolderExplorer/FolderExplorerContainer";
import { TFolderService, getFolderService } from "../services/draft-attachments-service";
import { InlineSubtleButton, PrimaryButton } from "../components/Primitives/Buttons";

interface TProps {
  matterId: string;
  folderService: TFolderService;
  filesRetriever: TFilesRetriever;

  onCancel(): void;
  onConfirm(): void;
  onFolderSelected?(folderId: string): void;
}

export const SelectFolderPage = () => {
  const filesRetriever = getFilesRetriever();
  const folderService = getFolderService();
  const params: { matterId: string } = useParams();
  const [ready, setReady] = useState(false);
  const [selectedFolderId, setSelectedFolderId] = useState<string | null>(null);

  const onCancel = () => sendEventToParent({ type: "CANCEL" });
  const onFolderSelected = (folderId: string) => setSelectedFolderId(folderId);
  const onConfirm = () => {
    const folderId = selectedFolderId ?? "";
    const display = "";
    sendEventToParent({ type: "SELECT_FOLDER", folderId, display });
  };

  useEffect(() => {
    childHandshake(() => {
      setReady(true);
    });
  }, []);

  return (
    <SelectFolderPageInjectable
      {...{
        ready,
        onCancel,
        onConfirm,
        onFolderSelected,
        folderService,
        filesRetriever,
        matterId: params.matterId,
      }}
    />
  );
};

export const SelectFolderPageInjectable = (props: TProps & { matterId: string; ready: boolean }) => {
  return (
    <div className="p-2 flex flex-col h-screen w-screen">
      <NotificationsContainer className="mx-2" showTopN={1} />

      {(props.ready && (
        <>
          <FolderExplorerContainer
            allowCreate={true}
            allowDelete={true}
            allowRename={true}
            selectMode="SINGLE"
            {...props}
            matterId={props.matterId}
          />
          <InlineSubtleButton onClick={() => props.onCancel()}>Cancel</InlineSubtleButton>
          <PrimaryButton className="ml-4" onClick={() => props.onConfirm()}>
            Select Folder
          </PrimaryButton>
        </>
      )) || <LoadingPresentational />}
    </div>
  );
};
